module.exports = __webpack_public_path__ + "img/map.e19a3794.png";